module.exports = __webpack_public_path__ + "img/13.8a4cb9a6.jpg";